import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_calendar.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-10026c99")

_pushScopeId("data-v-10026c99")
const _hoisted_1 = { class: "relative bg-white max-w-full m-auto flex-col flex rounded-2xl w-700px" }
const _hoisted_2 = { class: "border-b border-gray-lp-400" }
const _hoisted_3 = { class: "px-4 py-3 inline-flex justify-between w-full" }
const _hoisted_4 = { class: "font-semibold text-16px text-gray-lp-300" }
const _hoisted_5 = {
  style: {"max-height":"400px"},
  class: "px-3 py-3 dialog gap-y-4 flex flex-col overflow-y-auto scroll-height-modal"
}
const _hoisted_6 = { class: "border border-gray-lp-1400 rounded-2xl flex flex-col" }
const _hoisted_7 = { class: "flex flex-row justify-between items-center px-3 pt-3 pb-2 border-b border-gray-lp-1400" }
const _hoisted_8 = { class: "flex flex-row items-center gap-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "calendar"
}, null, -1)
const _hoisted_10 = { class: "flex flex-col gap-0.5" }
const _hoisted_11 = { class: "font-semibold text-gray-lp-2700 text-sm" }
const _hoisted_12 = { class: "font-semibold text-gray-lp-600 text-xs" }
const _hoisted_13 = { class: "w-full flex flex-row items-center px-3 pt-2 pb-3 gap-4" }
const _hoisted_14 = {
  class: "w-full flex flex-col gap-0.5 px-3 pt-2 pb-3 rounded-2xl",
  style: {"background":"linear-gradient(90.47deg, rgba(216, 238, 251, 0.3) 0.4%, rgba(173, 225, 255, 0.3) 80.08%)"}
}
const _hoisted_15 = { class: "font-bold text-black text-base" }
const _hoisted_16 = { class: "font-normal text-black-lp-100 text-sm" }
const _hoisted_17 = {
  key: 0,
  class: "inline-flex flex-row gap-x-2 overflow-auto w-full scroll-photo",
  style: {"max-width":"150px"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_card = _resolveComponent("card")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.openDialog)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          ref: "modal",
          tabindex: "0",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["esc"])),
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)), ["self"])),
          class: "justify-center items-center flex bg-overlay fixed inset-0 z-40 background-modal"
        }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('pusatResolusi.modalDex.detailValidDex')), 1),
                _createVNode("img", {
                  src: require(`@/app/ui/assets/svg/x-gray-24.svg`),
                  class: "w-5 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args))),
                  alt: "close"
                }, null, 8, ["src"])
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dexData, (dex, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index.toString()
                }, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode("div", _hoisted_10, [
                          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDateFormatting(dex.daDeliveryDexDate)), 1),
                          _createVNode("span", _hoisted_12, _toDisplayString(dex.daAssignedPartnerName), 1)
                        ])
                      ]),
                      (dex.daStatus)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: 
                  `py-1 px-1.5 rounded-2xl font-bold text-xs border ${
                    _ctx.mapStatus(dex.daStatus).style
                  }`
                
                          }, _toDisplayString(_ctx.mapStatus(dex.daStatus).label), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('pusatResolusi.modalDex.reason')), 1),
                        _createVNode("span", _hoisted_16, _toDisplayString(dex.daDeliveryReasonTitle), 1)
                      ]),
                      (dex.daDeliveryProofPhotoDex)
                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhoto(index), (photo, photoIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: photoIndex.toString(),
                                class: "flex h-full w-auto"
                              }, [
                                _createVNode(_component_card, {
                                  class: "relative p-1 rounded-lg border border-gray-lp-1500 bg-white",
                                  style: {"max-height":"max-content"}
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", {
                                      class: `relative flex`,
                                      onClick: ($event: any) => (_ctx.onPreview(index, photoIndex))
                                    }, [
                                      _createVNode("img", {
                                        src: photo,
                                        class: `object-cover rounded-lg`,
                                        style: {"width":"58px","height":"58px","min-width":"58px","min-height":"58px"},
                                        alt: "result-image"
                                      }, null, 8, ["src"])
                                    ], 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ], 544))
      : _createCommentVNode("", true),
    (_ctx.previewPhoto)
      ? (_openBlock(), _createBlock(_component_ImagePreview, {
          key: 1,
          onClose: _cache[4] || (_cache[4] = () => (_ctx.previewPhoto = false)),
          data: _ctx.proofPhoto(_ctx.dexIndex),
          initialIndex: _ctx.previewPhotoIndex
        }, null, 8, ["data", "initialIndex"]))
      : _createCommentVNode("", true)
  ], 64))
})